import { Badge } from "@/components/ui/badge";

// Origem do backup (`backup_history.source`) agrupada em chaves estáveis para filtro e rótulo.
export const ORIGEM_META = {
  "schedule-empresa": { label: "Agendado (horário da empresa)", badge: "Sistema (Agendado)", color: "bg-blue-100 text-blue-800 border-blue-300" },
  "schedule-global":  { label: "Agendado (global)",             badge: "Sistema (Global)",   color: "bg-blue-100 text-blue-800 border-blue-300" },
  manual:             { label: "Manual",                        badge: "Super Admin (Manual)", color: "bg-purple-100 text-purple-800 border-purple-300" },
  cron:               { label: "Cron diário",                   badge: "Sistema (Cron diário)", color: "bg-sky-100 text-sky-800 border-sky-300" },
  retry:              { label: "Retry",                         badge: "Retry (reprocessado)", color: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  "pre-reset":        { label: "Pré-reset",                     badge: "Sistema (Pré-reset)", color: "bg-amber-100 text-amber-800 border-amber-300" },
};
export const ORIGEM_KEYS = Object.keys(ORIGEM_META);

export function origemKey(source) {
  const s = source || "";
  if (s.startsWith("schedule-global")) return "schedule-global";
  if (s.startsWith("schedule")) return "schedule-empresa";
  return ORIGEM_META[s] ? s : "outro";
}

function origemBadgeText(source, key) {
  const base = ORIGEM_META[key].badge;
  if (!key.startsWith("schedule")) return base;
  const hora = /^schedule-(global-)?\d\d:\d\d$/.test(source) ? ` ${source.slice(-5)}` : "";
  return base.replace(")", `${hora})`);
}

export function OrigemBadge({ source }) {
  const key = origemKey(source);
  if (key === "outro") return <span className="text-slate-400">—</span>;
  return <Badge className={`${ORIGEM_META[key].color} text-[10px]`}>{origemBadgeText(source, key)}</Badge>;
}
